module.exports = __webpack_public_path__ + "static/media/bakri-steps-of-use-poster@3x.5c9c1d79.jpg";